import { BaseConfig } from '../ServiceConfig';

export interface SmartBannerConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.SmartBannerServiceConfigData';
  url: string;
  appId: string;
  cachingExpiredInDay: number;
  type: string;
}

export const SmartBannerConfigurationFields: (keyof SmartBannerConfiguration)[] = [
  'url',
  'appId',
  'cachingExpiredInDay',
  'type',
];

export const BlankSmartBannerConfiguration: SmartBannerConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.SmartBannerServiceConfigData',
} as SmartBannerConfiguration;
